import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./App.css";
import LoginNew from "./LandingPageNew/index";
import Login from "./LandingPage/index";
import Routing from "./Routes";
import { useNavigate, useLocation } from "react-router-dom";

const App = () => {
  const slug = useParams();

  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/*" element={<Routing />} />
      </Routes>
    </>
  );
};

export default App;
